import { createSlice } from "@reduxjs/toolkit";


const initialState = {
    loginStepOne: true,
    loginStepTwo: false,
    loginStep: 0,
    actionType: "Sign Up"
}

export const loginSlice = createSlice({
    name: "login", //?
    initialState,
    reducers:{
        reset: (state) => initialState,
        setLoginStep: (state, action) =>{
            state.loginStep = action.payload
        },

        incrementLoginStep: (state) =>{
            state.loginStep += 1
        },
        decrementLoginStep: (state) =>{
            state.loginStep -=1
        },
        resetLoginStep: (state) =>{
            state.loginStep = 0
        },
        setSignUp: (state) =>{
            state.actionType = "Sign Up"
        },
        setLogin: (state) =>{
            state.actionType = "Log In"
        }

    },
})

export const { reset, incrementLoginStep, decrementLoginStep, setSignUp, setLogin, resetLoginStep, setLoginStep } = loginSlice.actions;
export default loginSlice.reducer;
